import { Popup } from 'antd-mobile';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 0px;

  background: #ffffff;

  .adm-list-item.adm-plain-anchor {
    padding-left: 0px;

    .adm-list-item-content {
      padding: 0px 18px;
    }

    .anticon {
      svg {
        width: 18px;
        height: 18px;

        path {
          fill: ${props => props.theme.colors.text.secondary};
        }
      }
    }

    .adm-list-item-content-main {
      font-size: ${props => props.theme.font.size.xs};
      font-weight: ${props => props.theme.font.weight.regular};
      color: ${props => props.theme.colors.text.secondary};
    }

    .adm-list-item-content-arrow {
      width: 12px;
      height: 12px;

      svg {
        path {
          fill: ${props => props.theme.colors.text.secondary};
        }
      }
    }
  }
`;

export const HeaderShare = styled.div`
  height: 50px;
  padding: 0px 18px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CPopup = styled(Popup)`
  z-index: 2000;
  .adm-popup-close-icon {
    font-size: 23px;
    left: 10px !important;
    top: 10px !important;
  }
`;
